import { UserV2, UserV2Payload } from "@/types";

export const mapUserV2ToPayload = (user: UserV2): UserV2Payload => ({
  ...user,
  applications: user.applications.map((app) => app.id),
  clients: user.clients.map((client) => client.id),
  roles: user.role_associations.map((role) => ({
    id: role.id,
    tags: role.tags.map((tag) => tag.id),
  })),
  tags: user.tags.map((tag) => tag.id),
});
